// extracted by mini-css-extract-plugin
export var label = "locationKeyValue-module--label--31cc3";
export var labelWrapper = "locationKeyValue-module--labelWrapper--c026d";
export var locationKeyValue = "locationKeyValue-module--locationKeyValue--c8851";
export var svgWrapper = "locationKeyValue-module--svgWrapper--47518";
export var value = "locationKeyValue-module--value--07e0f";